import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import * as _ from 'underscore';
import { SubSink } from 'subsink';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState } from 'app/app.reducers';
import { getPrivateLabelLogo } from 'app/public/redux/public.selectors';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'sp-default-header',
  templateUrl: './default-header.component.html',
  styleUrls: ['./default-header.component.scss'],
  standalone: false
})
export class DefaultHeaderComponent implements OnDestroy {
  urls = ['', '/signup', '/resetpassword', '/resetpwdemailnotification'];
  showSignIn = true;
  privateLabelLogo$: Observable<string>;
  private subs = new SubSink();


  constructor(private router: Router, private store: Store<AppState>) {

    this.subs.sink = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.showSignIn = _.contains(this.urls, this.router.url);
      });

    this.privateLabelLogo$ = this.store.pipe(select(getPrivateLabelLogo));
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
